import { render } from "./HeadersRenderer.vue?vue&type=template&id=f9078d1c&scoped=true"
import script from "./HeadersRenderer.vue?vue&type=script&lang=js"
export * from "./HeadersRenderer.vue?vue&type=script&lang=js"

import "./HeadersRenderer.vue?vue&type=style&index=0&id=f9078d1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9078d1c"]])

export default __exports__